import React from 'react';
import { WorkplaceMemberSource } from '../../../../graphql/graphql';
import { Badge } from './EArchiveListItemStatusBadge';

interface Props {
	source: WorkplaceMemberSource;
}

const EArchiveListItemSourceBadge: React.FC<Props> = ({ source }) => {
	if (source === WorkplaceMemberSource.PartnerCalendar) {
		return <Badge title='base.reservationSystem' className='green' />;
	}

	return <></>;
};

export default EArchiveListItemSourceBadge;
